"use client"

import { useState } from "react"
import { Menu, X } from "lucide-react"
import { buttonClassName } from "@/components/ui/button"

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const navigation = [
    { name: "Nosotros", href: "#nosotros" },
    { name: "Soluciones", href: "#soluciones" },
    { name: "Proceso", href: "#proceso" },
  ]

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-header">
      <nav className="mx-auto max-w-7xl px-6 lg:px-8" aria-label="Global">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex lg:flex-1">
            <a href="/" className="-m-1.5 p-1.5">
              <img
                src="/hercode-logo.svg"
                alt="Hercode"
                className="h-9 w-auto"
              />
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-foreground"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span className="sr-only">Abrir menú</span>
              {mobileMenuOpen ? (
                <X className="h-6 w-6" aria-hidden="true" />
              ) : (
                <Menu className="h-6 w-6" aria-hidden="true" />
              )}
            </button>
          </div>

          {/* Desktop navigation */}
          <div className="hidden lg:flex lg:gap-x-10">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="font-work text-md font-medium text-text-header hover:text-text-header-hover transition-colors"
              >
                {item.name}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            <a
              href="#contacto"
              className={buttonClassName(
                "secondary",
                "bg-background-button-beige text-primary-foreground hover:opacity-90",
              )}
            >
              Contactar
            </a>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden pb-6">
            <div className="space-y-2">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="block rounded-lg px-3 py-2 text-base font-medium text-muted-foreground hover:bg-secondary hover:text-foreground transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </a>
              ))}
              <div className="pt-4">
                <a
                  href="#contacto"
                  className={buttonClassName("primary", "w-full")}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contactar
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  )
}
